import { WSPillProps } from "@wingspanhq/fe-component-library";

import { PayrollRunStatus } from "../types";

const PAYROLL_RUN_STATUS_PILL: Record<PayrollRunStatus, WSPillProps> = {
  pending: { theme: "warning", icon: true, text: "Pending" },
  opened: { theme: "blue", icon: "info-circle", text: "Opened" },
  processing: { theme: "warning", icon: true, text: "Processing" },
  completed: { theme: "success", icon: true, text: "Completed" },
  failed: { theme: "error", icon: true, text: "Failed" }
};

export const selectorPayrollRunStatusPill = (
  status: PayrollRunStatus
): WSPillProps => PAYROLL_RUN_STATUS_PILL[status];
